"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LikeFilter = void 0;
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var react_1 = __importStar(require("react"));
var fieldsProps_1 = require("../utils/fieldsProps");
function LikeFilter(props) {
    var column = props.column;
    var filterValue = column.filterValue, setFilter = column.setFilter, columnType = column.columnType, filterField = column.filterField;
    var filterType = 'like';
    var handleChange = react_1.useCallback(function (e) {
        var newValue = filterField
            ? { filterType: filterType, columnType: columnType, filterField: filterField, value: e.target.value }
            : { filterType: filterType, columnType: columnType, value: e.target.value };
        setFilter(newValue.value ? newValue : undefined);
    }, [setFilter]);
    var handleClear = react_1.useCallback(function () {
        setFilter(undefined);
    }, [setFilter]);
    return (react_1.default.createElement(core_1.TextField, __assign({}, fieldsProps_1.textFieldProps, { label: column.shortHeader, value: (filterValue === null || filterValue === void 0 ? void 0 : filterValue.value) || '', onChange: handleChange, InputProps: {
            endAdornment: (react_1.default.createElement(core_1.InputAdornment, { position: "end" },
                react_1.default.createElement(core_1.IconButton, { size: "small", onClick: handleClear },
                    react_1.default.createElement(icons_1.Clear, null)))),
        } })));
}
exports.LikeFilter = LikeFilter;
